import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import UpdateClassroomDTO from '../models/classroom/UpdateClassroomDTO';
import ClassroomDTO from '../models/classroom/ClassroomDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import AddClassroomDTO from '../models/classroom/AddClassroomDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';

export class ClassroomApiController {
    // post: Classroom/AddClassroom
    public RouteAddClassroom = () => `Classroom/AddClassroom`;
    public addClassroom(addClassroomDTO: AddClassroomDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<number>>> {
        let url = this.RouteAddClassroom();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<number>>(addClassroomDTO, 'post', url, requestOptions);
    }
    // post: Classroom/UpdateClassroom
    public RouteUpdateClassroom = () => `Classroom/UpdateClassroom`;
    public updateClassroom(updateClassroomDTO: UpdateClassroomDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateClassroom();
        return HttpApi.RestRequest<any, void>(updateClassroomDTO, 'post', url, requestOptions);
    }
    // post: Classroom/DeleteClassroom/${classroomId}
    public RouteDeleteClassroom = (classroomId: number) => `Classroom/DeleteClassroom/${classroomId}`;
    public deleteClassroom(classroomId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteDeleteClassroom(classroomId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: Classroom/GetClassroom/${classroomId}
    public RouteGetClassroom = (classroomId: number) => `Classroom/GetClassroom/${classroomId}`;
    public getClassroom(classroomId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateClassroomDTO>> {
        let url = this.RouteGetClassroom(classroomId);
        return HttpApi.RestRequest<any, UpdateClassroomDTO>(null, 'get', url, requestOptions);
    }
    // post: Classroom/GetClassroomTableData
    public RouteGetClassroomTableData = () => `Classroom/GetClassroomTableData`;
    public getClassroomTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<ClassroomDTO>>> {
        let url = this.RouteGetClassroomTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<ClassroomDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new ClassroomApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/ClassroomApiController.ts